import eventListeners from './event-listeners';
import documentMouseUpHandler from '../handlers/document-mouse-up-handler';

const mouseUpListener = (element) => {
  eventListeners.add(element, 'mouseup', documentMouseUpHandler);
};

export default mouseUpListener;
